import { MQ_SMALL_ONLY, MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base3x2, large3x2, medium3x2, medium4x5, small3x2 } = IMAGE_SIZES;

const base = {
  fallbackDims: base3x2,
  sourceSets: [
    {
      layoutWidth: { value: 367, units: 'px' },
      imageDims: large3x2,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 310, units: 'px' },
      imageDims: medium3x2,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 224, units: 'px' },
      imageDims: small3x2,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 200, units: 'px' },
      imageDims: medium4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 3 / 2
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = [];

export default {
  base,
  exceptionPatterns
};
